
import { Component, Prop, Vue } from "vue-property-decorator";

import CircleWithInitials from "@/components/card/CircleWithInitials.vue";
import S3Image from '@/components/common/s3-image.vue';

@Component({
  components: {
    CircleWithInitials,
    S3Image,
  },
})
export default class NavbarAvatar extends Vue {
  @Prop({ type: String, default: undefined }) readonly avatar?: string;
  @Prop({ type: String, required: true }) readonly title!: string;
  @Prop({ type: Boolean, default: false }) readonly pointer!: boolean;
}
